// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiCollectedStatsSeason {
    'season': string;
    'total_cards_in_season': number;
    'sets_held': number;
    'partial_set_unique_cards_held': number;
    'total_cards_held': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "season",
            "baseName": "season",
            "type": "string",
            "format": ""
        },
        {
            "name": "total_cards_in_season",
            "baseName": "total_cards_in_season",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "sets_held",
            "baseName": "sets_held",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "partial_set_unique_cards_held",
            "baseName": "partial_set_unique_cards_held",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "total_cards_held",
            "baseName": "total_cards_held",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiCollectedStatsSeason.attributeTypeMap;
    }

    public constructor() {
    }
}
